export function formatCurrency(amount = 0) {
  const value = amount == null || Number.isNaN(Number(amount)) ? 0 : Number(amount);

  return new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: "ARS",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}
